/**
 * useMyDealerState Hook
 * Centralizes state management for My Dealer feature
 * Combines Redux selectors and local state
 */

import { useState } from "react";
import { useSelector, shallowEqual } from "react-redux";
import {
  CLUSTER_CODE_PLACEHOLDER,
  TERRITORY_PLACEHOLDER,
  DEALER_PLACEHOLDER,
} from "./constants";

export const useMyDealerState = () => {
  // ===== Redux Selectors =====
  const territoryOptions = useSelector(
    (state) => state?.territory?.territoryDetails,
    shallowEqual
  );

  const userType = useSelector(
    (state) =>
      state?.userType?.type !== "Other"
        ? state?.userType?.type
        : state?.userDetails?.details?.Title,
    shallowEqual
  );

  const clusterCodeOption = useSelector(
    (state) => state?.clusterCode?.clusterCodeList,
    shallowEqual
  );

  const tourPlanDefaultData = useSelector(
    (state) => state?.upcomingTourPlan?.upcomingTourDetails?.records,
    shallowEqual
  );

  const salesGroupCode = useSelector(
    (state) => state?.userDetails?.details?.Sales_Group_Code__c,
    shallowEqual
  );

  const userEmail = useSelector(
    (state) => state?.userDetails?.details?.Email,
    shallowEqual
  );


  // ===== Local State =====
  // Dealer selection
  const [dealerOption, setDealerOption] = useState([]);
  const [selectLatLong, setSelectLatLong] = useState(DEALER_PLACEHOLDER);
  const [dealer, setDealer] = useState("");
  const [dealerCode, setDealerCode] = useState(0);
  const [accuracy, setAccuracy] = useState(0);

  // Territory selection
  const [selectedTerritory, setSelectedTerritory] = useState(TERRITORY_PLACEHOLDER);
  const [territoryPickList, setTerritoryPickList] = useState([]);
  const [territoryCheckIn, setTerritoryCheckIn] = useState("");
  const [sh3CodeForTerritory, setSH3CodeForTerritory] = useState("");

  // Cluster selection
  const [cluster, setCluster] = useState(CLUSTER_CODE_PLACEHOLDER);

  // UI State
  const [loading, setLoading] = useState(false);
  const [isDealerData, setIsDealerData] = useState("");
  const [isChecked, setIsChecked] = useState(false);

  // Modals
  const [isDealerPopupOpen, setIsDealerPopupOpen] = useState(false);
  const [isMyDiaryOpen, setIsMyDiaryOpen] = useState(false);
  const [isMySROpen, setIsMySROpen] = useState(false);
  const [isPreviousObservationOpen, setIsPreviousObservationOpen] = useState(false);

  // Check-in related
  const [checkinFlag, setCheckinFlag] = useState(false);
  const [autoCheckInFlag, setAutoCheckInFlag] = useState(false);
  const [recordId, setRecordId] = useState("");

  // Other states
  const [getSummeryList, setGetSummeryList] = useState({});
  const [reloadDealerStatusFlag, setReloadDealerStatusFlag] = useState(false);

  // ===== Return all state and setters =====
  return {
    // Redux state
    territoryOptions,
    userType,
    clusterCodeOption,
    tourPlanDefaultData,
    salesGroupCode,
    userEmail,

    // Dealer state
    dealerOption,
    setDealerOption,
    selectLatLong,
    setSelectLatLong,
    dealer,
    setDealer,
    dealerCode,
    setDealerCode,
    accuracy,
    setAccuracy,

    // Territory state
    selectedTerritory,
    setSelectedTerritory,
    territoryPickList,
    setTerritoryPickList,
    territoryCheckIn,
    setTerritoryCheckIn,
    sh3CodeForTerritory,
    setSH3CodeForTerritory,

    // Cluster state
    cluster,
    setCluster,

    // UI state
    loading,
    setLoading,
    isDealerData,
    setIsDealerData,
    isChecked,
    setIsChecked,

    // Modals
    isDealerPopupOpen,
    setIsDealerPopupOpen,
    isMyDiaryOpen,
    setIsMyDiaryOpen,
    isMySROpen,
    setIsMySROpen,
    isPreviousObservationOpen,
    setIsPreviousObservationOpen,

    // Check-in related
    checkinFlag,
    setCheckinFlag,
    autoCheckInFlag,
    setAutoCheckInFlag,
    recordId,
    setRecordId,

    // Other
    getSummeryList,
    setGetSummeryList,
    reloadDealerStatusFlag,
    setReloadDealerStatusFlag,
  };
};

export default useMyDealerState;
